import React, { useEffect } from 'react';
import {
  updateShopifyShopWithCompany,
  setShopifyParams,
  getShopifyParams,
} from '../../../../utils';
import { ESellerStore } from '../../../../Types';
import { updateCompany } from 'frontend/src/components/API';
import Signup from './Signup';
import { useQuery } from 'frontend/src/hooks/useQuery';

export default function Signup8Data() {
  const query = useQuery();

  async function handlePostSignUp() {
    const shopifyData = getShopifyParams();
    const companyName = shopifyData?.shop?.split('.')[0] || '';
    await updateCompany({
      seller_store: ESellerStore.shopify,
      name: companyName,
    });
    await updateShopifyShopWithCompany();
  }

  useEffect(() => {
    setShopifyParams(query);
  }, [query]);

  return (
    <Signup
      enableGoogleSignIn={false}
      handlePostSignUp={handlePostSignUp}
      enableBack={false}
    />
  );
}
